import React from "react"
import {FormattedMessage} from "react-intl"
import messages from "./messages"
import { Button } from '@arnsbogroup/react-voicearchive'

const DownloadCsv = ({ orders = [], fileName = 'ErrorRates'}) => {
    const onDownloadCsv = () => {
        if (!(!!orders.length)) {
            return
        }
        const headers = Object.keys(orders[0])
        const csvContentEntries = orders
        const csvContent =
            "data:text/csvcharset=utf-8," +
            [headers.join(','), ...csvContentEntries.map((row) => headers.map(header => row[header]).join(','))].join('\n')
        const encodedUri = encodeURI(csvContent)

        const link = document.createElement('a')
        link.setAttribute('href', encodedUri)
        link.setAttribute('download', `${fileName}.csv`)

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    if (!(!!orders.length)) {
        return null
    }

    return (
        <Button
            onClick={() => onDownloadCsv()}
            size="xs"
            variant="inline"
        >
            <FormattedMessage {...messages.export} />
        </Button>
    )
}

export default DownloadCsv
